export const workflowSteps = ['Block::Code', 'Block::UserFields'];
export const nonWorkflowSteps = ['Block::UserForm'];

export const workflowSelectorClass = 'Block::WorkflowSelector';
